// Dependencies
import { graphql, useStaticQuery } from 'gatsby';

const useMatchmakingStepsOptions = () => {
  const { options } = useStaticQuery(graphql`
    query MatchmakingStepsOptions {
      options: wp(global: {}) {
        global {
          steps: matchmakingSteps {
            heading: matchmakingStepsHeading
            subheading: matchmakingStepsSubheading
            steps: matchmakingStepsSteps {
              heading
              text
              icon {
                altText
                localFile {
                  publicURL
                }
                mediaDisplayOptions {
                  filter
                }
              }
            }
          }
        }
      }
    }
  `);

  return options?.global?.steps;
};

export default useMatchmakingStepsOptions;
